import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getUsers = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(`v1/user/user?${queryParams}`, { method: "GET" });
};
